import alt from 'epic-react-common/src/alt';
// import { Immutable } from 'seamless-immutable';
import { datasource } from 'alt-utils/lib/decorators';
import NewsLetterActions from '../actions/NewsLettersActions';
import NewsLetterSource from '../sources/NewsLetterSource';

@datasource(NewsLetterSource)
class NewsLetterStore {
    constructor() {
        this.state = {
            loading: false,
            isLoggedIn: false,
            email: '',
            success: false,
            checked: false,
            hasSubscribed: false
        };

        this.bindActions(NewsLetterActions);
        this.registerAsync(NewsLetterSource);
    }

    onGetSubscriptionStatus(data) {
        this.setState({
            loading: true,
            errorMsg: ''
        });
        this.getInstance().getSubscriptionStatus(data);
    }

    onGetSubscriptionStatusSuccess(response) {
        if (response && response.data && !response.data.error) {
            const state = response.data;
            state.loading = false;
            state.checked = true;
            state.hasSubscribed = response.data.listSubscribed && response.data.productSubscribed;
            this.setState(state);
        } else if (response.data.error) {
            this.setState({
                loading: false,
                checked: true,
                errorMsg: response.data.errormsg
            });
        } else {
            console.error('Unknow Error', response);
            this.setState({
                loading: false,
                checked: true
            });
        }
    }

    onGetSubscriptionStatusFailure(response) {
        console.error('onGetSubscriptionStatusFailure() could not load comments data into store');
        this.setState({
            loading: false
        });
    }

    onSignUpNewsLetter(data) {
        this.setState({
            loading: true,
            errorMsg: ''
        });
        this.getInstance().signUpNewsLetter(data);
    }

    onSignUpNewsLetterSuccess(response) {
        if (response && response.data && response.data.ok) {
            this.setState({
                loading: false,
                success: true
            });
        } else if (response.data.error) {
            this.setState({
                loading: false,
                checked: false,
                errorMsg: response.data.errormsg
            });
        } else {
            console.error('Unknow error!', response);
            this.setState({
                loading: false,
                checked: false
            });
        }
    }

    onSignUpNewsLetterFailure(response) {
        console.error('onSignUpNewsLetterFailure()');
        this.setState({
            loading: false
        });
    }
}

export default alt.createStore(NewsLetterStore, 'NewsLetterStore');



// WEBPACK FOOTER //
// ./app/scripts/stores/NewsLetterStore.js